<template>
  <div class="fixed right-10 top-10 z-50">
    <FwbToast
      v-for="toast in toastsStore.toShow"
      :key="toast.id"
      divide
      :type="toast.type"
      class="mb-2 shadow-xl"
      data-test="toast"
    >
      {{ toast.message }}
    </FwbToast>
  </div>
</template>

<script setup lang="ts">
import { FwbToast } from "flowbite-vue";

/**
 * Display toasts from the store.
 */
import { TIMEOUT, useToastsStore } from "~/stores/toasts";

const toastsStore = useToastsStore();
/**
 * Every time the toastsStore.toShow changes, we want to check if there are any new toasts.
 * If there are, we want to mark them as shown after a timeout.
 */
watch(
  () => toastsStore.toShow,
  (newToasts, oldToasts) => {
    const oldToastIDs = oldToasts.map((toast) => toast.id);
    const newToastIDs = newToasts.map((toast) => toast.id);
    const brandNewToastIDs = newToastIDs.filter((id) => !oldToastIDs.includes(id));
    if (brandNewToastIDs.length > 0) {
      setTimeout(() => {
        brandNewToastIDs.forEach((id) => {
          toastsStore.markToastAsShown(id);
        });
      }, TIMEOUT);
    }
  },
);
</script>
